export enum StickyZoneShape {
  Rectangle = 'Rectangle',
  Circle = 'Circle',
}

const StickyZoneShapeMap: { [key in StickyZoneShape]: StickyZoneShape } = {
  [StickyZoneShape.Rectangle]: StickyZoneShape.Rectangle,
  [StickyZoneShape.Circle]: StickyZoneShape.Circle,
} as const;

const StickyZoneShapeList = Object.values(StickyZoneShapeMap);

export namespace StickyZoneShape {
  export function values(): Readonly<StickyZoneShape[]> {
    return StickyZoneShapeList;
  }

  export function load(value: string): StickyZoneShape {
    return isStickyZoneShape(value) ? value : StickyZoneShape.Rectangle;
  }

  export function dump(shape: StickyZoneShape): 'Rectangle' | 'Circle' {
    return shape;
  }
}

function isStickyZoneShape(value: string): value is StickyZoneShape {
  return StickyZoneShapeList.some((shape) => value === shape);
}
